var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('emd-card',[_c('emd-card-header',[_c('emd-text',{attrs:{"size":"section"}},[_vm._v(" "+_vm._s(_vm.$t('keys.api-data'))+" ")])],1),_c('emd-card-content',[_c('alert-test-account',{attrs:{"show":_vm.isTestAccount}}),_c('version'),_c('account-id'),_c('public-key')],1)],1),_c('secret-keys')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }